import actionTypes from 'redux/actions/actionTypes';

export default function toggleFullWidth() {
  return { type: actionTypes.TOGGLE_FULL_WIDTH };
}

export function setFullWidth(fullWidth = true) {
  return { type: actionTypes.SET_FULL_WIDTH, fullWidth };
}
